import React from "react";
import { Spinner, Button } from "react-bootstrap";
import styled from "styled-components";

const StyledSpinnerDiv = styled.div`
  position: absolute;
  left: 48.5%;
`;

const LoadingButton = (text: string, mOnClick: () => void, id = "loadingButton", minimumLoadTime = 500, style: any = {}, className: string = "", variant: string = "", buttonImage = <></>, isDisabled = false) => {
    if (style.position && style.position != "relative")
        console.warn("LoadingButton; overriding style.position to be 'relative' for correct functionality, was: " + style.position);
    style.position = "relative"; // Makes sure the spinner is correctly positioned
    return (
        <Button
            variant={variant}
            style={style}
            className={className}
            title={text}
            id={id}
            onClick={async () => {
                await PressButton(mOnClick, id, minimumLoadTime);
            }}
            disabled={isDisabled}
        >
            <StyledSpinnerDiv id={id + "_spinner"} style={{ visibility: "hidden" }}>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            </StyledSpinnerDiv>
            <p style={{marginBottom: 0}}>{buttonImage}{text}</p>
        </Button>
    );
};

async function PressButton(mOnClick: Function, id = "loadingButton", minimumLoadTime = 500) {
    var html = document.getElementById(id);
    if (html == null) {
        console.error("Could not find button with id " + id + ", executing without spinner")
        await mOnClick()
        return;
    }

    const button = html as HTMLButtonElement;
    var spinnerDiv = document.getElementById(id + "_spinner");
    button!.disabled = true;
    spinnerDiv!.style.visibility = "visible";
    var timerPromise = new Promise(resolve => {
        setTimeout(() => resolve(true), minimumLoadTime);
    });
    var onClickPromise = mOnClick()
    Promise.allSettled([timerPromise, onClickPromise]).then(() => {
        button!.disabled = false;
        spinnerDiv!.style.visibility = "hidden";
    })
}

export { LoadingButton, PressButton };